import { FC } from 'react';

export type ErrorMessageProps = {
  message: null | string | undefined;
};

export const ErrorMessage: FC<ErrorMessageProps> = ({
  message
}) => {
  return (!message) ? null : (
    <p className="container-error rounded-s">{message}</p>
  );
};
